<template>
  <div>
    <Modal :footer-hide="true" :mask-closable="false" v-model="show" title="复制专利" :width="1050">
      <table class="QHtable">
        <tr>
          <th colspan="10" class="QHbtnML10">
            <div class="flex-between">
              <p>正在复制专利{{ list.length }}件</p>
              <p>
                <Button type="success" @click="$refs.Osgaijia.hello('复制专利价格修改')" v-show="showPrice">修改价格</Button>
                <Button type="primary" @click="copy()">一键复制</Button>
              </p>
            </div>
          </th>
        </tr>
        <tr>
          <th style="width: 80px">编号</th>
          <th style="width: 100px; text-align: center">专利类型</th>
          <th style="width: 100px; text-align: center">专利状态</th>
          <th style="width: 120px; text-align: center">专利号</th>
          <th>专利名称</th>
          <th style="text-align: center; width: 110px" v-show="showPrice">平台原价</th>
          <th style="text-align: center; width: 110px" v-show="showPrice">复制价格</th>
        </tr>
        <tr v-for="(item, index) in list" :key="index">
          <td>{{ index + 1 }}</td>
          <td style="text-align: center">{{ $s("zhuanKind", item.kind) }}</td>
          <td style="text-align: center">{{ $s("zhuanType", item.type) }}</td>
          <td style="text-align: center">{{ item.applicationNumber }}</td>
          <td v-html="item.title"></td>
          <td style="text-align: center" v-show="showPrice">{{ $amount(item.price) }}</td>
          <td style="text-align: center" v-show="showPrice">
            <span class="hotFont1">{{ $amount(item.NewPrice) }}</span>
          </td>
        </tr>
      </table>
    </Modal>
    <Osgaijia ref="Osgaijia" @updataPrice="updataPrice"></Osgaijia>
  </div>
</template>
<script>
import Osgaijia from "@/components/Osgaijia/Osgaijia";
export default {
  name: "Oscopy",
  components: {
    Osgaijia,
  },
  data() {
    return {
      show: false,
      showPrice: false,
      list: "",
    };
  },
  props: {
    // 弹窗显示隐藏
    title: {
      type: String,
      default: "",
    },
  },
  methods: {
    // +----------------------------------------------------------------------
    // | Desc:复制预览
    // +----------------------------------------------------------------------
    hello(list, showPrice) {
      this.showPrice = showPrice;
      list = list.map((item) => {
        return {
          ...item, // 保留原有属性
          NewPrice: item.price, // 添加 NewPrice 属性
        };
      });
      this.list = list;
      this.show = true;
    },

    // +----------------------------------------------------------------------
    // | 列表中复制专利信息
    // +----------------------------------------------------------------------
    copy() {
      var that = this;
      //组合需要复制的数据
      const data = that.list;

      //数据拼装
      var copyText = "";
      for (var i = 0; i < data.length; i++) {
        var item = data[i];
        var item=that.$removeKeywordTags(item);
        var zhuanKind = that.$s("zhuanKind", item.kind) || "";
        var zhuanType = that.$s("zhuanType", item.type) || "";
        copyText += i + 1 + " 、"; //序号
        copyText += zhuanKind + " "; //类型
        copyText += zhuanType + " "; //状态
        copyText += item.applicationNumber + " "; //专利号
        copyText += item.title + " "; //专利名
        if (that.showPrice&&!that.$isblank(item.NewPrice)) {
          copyText +=that.$amount(item.NewPrice) + " "; //价格
        }
        copyText += "\n\n";
      }
      this.$copyText(copyText);
    },

    // +----------------------------------------------------------------------
    // | Desc:去掉首尾中英文括号
    // +----------------------------------------------------------------------
    trimParentheses: function (str) {
      const regex = /^[\（\（\）\）]*(.*?)[\（\（\）\）]*$/;
      const result = str.match(regex);
      return result ? result[1] : str;
    },

    // +----------------------------------------------------------------------
    // | Desc:修改list的NewPrice价格，基价是Price
    // | Price{
    // |     "updataPriceType": "100",//100按照百分比加价,200按照价格修改加价
    // |     "updataPriceKind100": "100",//kind=100的修改数据
    // |     "updataPriceKind200": "100",//kind=200的修改数据
    // |     "updataPriceKind300": "100"//kind=300的修改数据
    // | }
    // +----------------------------------------------------------------------
    updataPrice: function (Price) {
      var list = this.list;
      for (var i = 0; i < list.length; i++) {
        //基本数据
        var item = list[i];
        var NewPrice = item.price;

        //执行改价
        if (item.price != "售价面议") {
          //修改发明专利价格
          if (item.kind == 100) {
            if (Price.updataPriceType == 100) {
              var NewPrice = item.price * (1 + Price.updataPriceKind100 / 100);
            } else if (Price.updataPriceType == 200) {
              var NewPrice = item.price + Price.updataPriceKind100;
            } else {
              var NewPrice = item.price * (1 + Price.updataPriceKind100 / 100);
            }
          }

          //修改新型实用专利价格
          if (item.kind == 200) {
            if (Price.updataPriceType == 100) {
              var NewPrice = item.price * (1 + Price.updataPriceKind200 / 100);
            } else if (Price.updataPriceType == 200) {
              var NewPrice = item.price + Price.updataPriceKind200;
            } else {
              var NewPrice = item.price * (1 + Price.updataPriceKind200 / 100);
            }
          }

          //修改外观实用专利价格
          if (item.kind == 300) {
            if (Price.updataPriceType == 100) {
              var NewPrice = item.price * (1 + Price.updataPriceKind300 / 100);
            } else if (Price.updataPriceType == 200) {
              var NewPrice = item.price + Price.updataPriceKind300;
            } else {
              var NewPrice = item.price * (1 + Price.updataPriceKind300 / 100);
            }
          }

          //整数化
          var NewPrice = parseInt(NewPrice);
        }

        //数据整合
        item.NewPrice = NewPrice;
        list[i] = item;
      }
      //根据 type 分组展示
      this.list = list;
    },
  },
};
</script>
